<template>
  <div class="navigation-bar">
    <button
      class="navigation__button navigation__button--previous"
      @click="navigatePrevious"
    >
      &#129044; Arrow back
    </button>
    <button
      class="navigation__button navigation__button--next"
      @click="navigateNext"
    >
      &#129044; Arrow next
    </button>
  </div>
</template>

<script>
import store from "@/store";

export default {
  methods: {
    findProjectById(id) {
      return store.projects.find((project) => project.id === id);
    },
    navigatePrevious() {
      const currentProjectId = 2;
      const previousProject = this.findProjectById(
        parseInt(currentProjectId) - 1
      );
      if (previousProject) {
        this.$router.push({
          name: "ProjectDetails",
          params: { id: previousProject.id },
        });
      }
    },
    navigateNext() {
      const currentProjectId = this.$route.params.id;
      const nextProject = this.findProjectById(parseInt(currentProjectId) + 1);
      if (nextProject) {
        this.$router.push({
          name: "ProjectDetails",
          params: { id: nextProject.id },
        });
      }
    },
  },
};
</script>

<style scoped>
.navigation-bar {
  display: flex;
  justify-content: space-between;
}
.navigation-bar__title {
  font-size: 48px;
  color: var(--color-white);
}
.navigation__button {
  border: 2px solid var(--color-yellow);
  border-radius: 10px;
  padding: 10px 20px;
  background: none;
  color: #f6d23e;
  font-size: 16px;
  cursor: pointer;
}
.navigation__button--previous {
  border: 2px solid #000000;
}
</style>
